import { getBackendApiUrl } from "./appConfig.js";

const buildApiUrl = (path) => {
  const baseUrl = getBackendApiUrl();
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return `${baseUrl}${cleanPath}`;
};

export const apiUrl = {
  users: () => buildApiUrl("/api/users/"),
  userById: (id) => buildApiUrl(`/api/users/${id}`),
  updateUser: () => buildApiUrl("/api/users/update"),

  tools: () => buildApiUrl("/api/tools/"),
  toolById: (id) => buildApiUrl(`/api/tools/${id}`),
  unapprovedTools: () => buildApiUrl("/api/tools/unapproved"),
  approveTool: (id) => buildApiUrl(`/api/tools/${id}/approve`),
  rejectTool: (id) => buildApiUrl(`/api/tools/${id}/reject`),
  remindTool: (id) => buildApiUrl(`/api/tools/${id}/remind`),
  downloadTool: (filePath) =>
    buildApiUrl(`/api/tools/download/${encodeURIComponent(filePath)}`),

  categories: () => buildApiUrl("/api/categories/"),
  categoryById: (id) => buildApiUrl(`/api/categories/${id}`),
  tags: () => buildApiUrl("/api/tags/"),

  notificationSubscribers: () =>
    buildApiUrl("/api/notifications/subscribers"),
  notificationSubscriberById: (id) =>
    buildApiUrl(`/api/notifications/subscribers/${id}`),
};

export { buildApiUrl };
